import { Flex, Input } from "antd";
import { IoSearch } from "react-icons/io5";
import { RiMenu3Fill } from "react-icons/ri";

const boxStyle: React.CSSProperties = {
  width: "100%",
  borderRadius: 6,
};
const inputSearchStyle: React.CSSProperties = {
  borderRadius: "25px",
  border: "none",
};
const settingIconStyle: React.CSSProperties = {
  height: "33px",
  width: "33px",
  cursor: "pointer",
};

const searchIconStyle: React.CSSProperties = {
  height: "20px",
  width: "20px",
  color: "#6b7280",
  cursor: "pointer",
};


const UserDidHeader = ({
  setSearchInput,
  setSidebarOpen,
  sidebarOpen
}: {
  setSearchInput: Function;
  setSidebarOpen?: Function;
  sidebarOpen?: boolean
}) => {

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value);
  };

  return (
    <div style={{
      padding: "18px",
      borderBottom: "1px solid rgb(223, 226, 232)",
      minHeight: "70px"
    }}>
      <Flex style={boxStyle} justify={"space-between"} align={"flex-start"}>
        <Input
          onChange={handleSearch}
          style={inputSearchStyle}
          size="middle"
          placeholder="Search"
          prefix={<IoSearch style={searchIconStyle} />}
        />
        <RiMenu3Fill onClick={() => setSidebarOpen && setSidebarOpen(!sidebarOpen)} style={settingIconStyle} />
      </Flex>
    </div>
  );
};

export default UserDidHeader;
